import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

// 환경값을 런타임 설정에 주입한다(부수효과). 첫 API 호출 전에 실행되도록 맨 위에서 import 한다.
import '@/lib/env';
import { App } from '@/App';
import { detectBackend } from '@/lib/loungeCompat';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root 엘리먼트를 찾을 수 없습니다.');

// 어느 서버에 붙었는지(라운지 / 안전 서버) 먼저 안다 — 첫 API 호출의 이름이 거기에 달렸다(lib/loungeCompat).
void detectBackend().then(() => {
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
});
